<template>
  <div>
   <!-- Mobile verification: shown once the backend has accepted every field
        and texted a code. The account is not created until this passes. -->
   <v-dialog v-model="otpdialog" persistent max-width="420px">
     <v-card>
       <v-card-title class="justify-center">Verify your mobile</v-card-title>
       <v-card-text class="text-center">
         <p class="mb-4">
           We've sent a 6 digit code to <strong>{{ phone }}</strong>.
         </p>
         <div class="red--text mb-2">{{ otperror }}</div>
         <v-form @submit.prevent="verifyotp" ref="otpform" lazy-validation>
           <v-text-field v-model="otp" outlined hide-details="auto" maxlength="6" inputmode="numeric"
             label="Enter 6 digit code" :rules="otpRule" autofocus></v-text-field>
           <!-- local development only: the backend returns the code instead of texting it -->
           <div v-if="testcode" class="green--text text-left mt-2 caption">
             Test mode — SMS not delivered; use the code shown below.
             (test code: <strong>{{ testcode }}</strong>)
           </div>
           <v-btn type="submit" :loading="otploading" :disabled="otploading" color="primary"
             class="mt-4" block>Verify &amp; Create Account</v-btn>
         </v-form>
         <div class="mt-4">
           <span v-if="resendin > 0" class="grey--text">Resend code in {{ resendin }}s</span>
           <a v-else href="#" @click.prevent="resendotp">Resend code</a>
         </div>
         <div class="mt-2">
           <a href="#" @click.prevent="closeotp" class="grey--text">Change my details</a>
         </div>
       </v-card-text>
     </v-card>
   </v-dialog>
   <v-form @submit.prevent="validate" ref="form" lazy-validation>
    <v-card-text>
     <v-row>
      <v-col id="errordivtop">
        <template>
          <p class="text-justify">
            This sign up page is for DamnN International so although you are signing up for myvoco or QuizStar or DROAD or Sportstrade it is all DamnN International.
          </p>
          <p class="text-justify">
            After you have filled out this form you will receive a personal DamnN International number that will be sent to your email.
          </p>   
          <p class="text-justify"> 
            All the information is important because there will be opportunities that arise that will be in certain locations and areas will have the chance to win cash and prizes.
          </p>   
         </template> 
      </v-col>
    </v-row>
    <v-alert v-if="errorlist.length" ref="errorbox" type="error" text dense class="text-left mt-2 mb-3">
      <div v-for="(err, i) in errorlist" :key="i">{{ err }}</div>
    </v-alert>
    <v-row>
      <v-col cols="6">
        <v-text-field v-model="firstname" :rules="firstnameRule" hide-details="auto" outlined label="First Name *" required></v-text-field>
      </v-col>
      <v-col col="12" md="6" sm="6">
        <v-text-field v-model="lastname" :rules="lastnameRule" hide-details="auto" outlined label="Surname *" required></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col col="12" md="6" sm="6">
        <v-text-field v-model="email" :rules="emailRules" hide-details="auto"  outlined label="Email Address *" required></v-text-field>
      </v-col>
      <v-col col="12" md="6" sm="6">
        <v-text-field v-model="phone" :rules="phoneRule" hide-details="auto" outlined label="Mobile *" placeholder="+14155551234"
          persistent-hint hint="Include your country code — we'll text a code to verify it." required></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field v-model="dob" :rules="dobRule" hide-details="auto" outlined type="date" label="Date of Birth *"
          :max="maxdob" required></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field v-model="suburb" :rules="suburbRule" hide-details="auto" outlined label="City or Suburb *" required></v-text-field>
      </v-col>
    </v-row>
     <v-row>
       <v-col cols="6">
          <v-text-field
            v-model="password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRule"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="Password"
            hint="At least 6 characters"
            counter
            hide-details
            outlined
            @click:append="show1 = !show1"
          ></v-text-field>
                </v-col>
             
                <v-col cols="6">
                <v-text-field
                        v-model="confirmpassword"
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="confirmpasswordRule"
                        :type="show2 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Confirm Password"
                        hint="At least 6 characters"
                        counter
                        hide-details
                        outlined
                        @click:append="show2 = !show2"
          ></v-text-field>   </v-col>
              </v-row>
             
               <v-row>
                <v-col cols="6">
                  <v-select v-model="region" hide-details outlined :rules="regionRule" @change="stateslist($event)" :items="regions" label="Country" required></v-select>
                </v-col>
             
                <v-col cols="6">
                   <v-autocomplete id="stateid" hide-details outlined  @change="selectcities($event)" :rules="stateidRule" v-model="stateid" :items="statesarr" item-text="state_name" item-value="state_id"   
                       filled label="State / County / Area / Region"  class="p-0" background-color="white"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="postcode" :rules="postcodeRule" hide-details="auto" outlined label="Post Code / Zip Code *" required></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="captchaAnswer" :rules="captchaRule" hide-details="auto" outlined
                    :label="'What is ' + captchaA + ' + ' + captchaB + '? *'" required></v-text-field>
                </v-col>
              </v-row>

            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" :loading="makedisable" :disabled="makedisable" color="primary">Continue</v-btn>
              <v-spacer />
            </v-card-actions>
         
          </v-form>
    
 
    </div>
</template>

<script>
//import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
export default {
  name: "Register",
  //components: {DatePick},
  data() {
    return {
      logo: '',
      damnnogo: '',
      makedisable:false,
      region: "",
      phone:"",
      regions: ["America", "Australia", "United Kingdom","New Zealand"],
      username:"",
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      gender:"",
      city:"", 
      stateid:"",
      cityname:"",
      suburb:"",
      postcode:"",
      statesarr:[],
      citiesarr:[],
      confirmpassword:"",
      dob:"",
      captchaA:0,
      captchaB:0,
      captchaAnswer:"",
      otpdialog:false,
      otp:"",
      testcode:"",
      otperror:"",
      otploading:false,
      resendin:0,
      resendtimer:null,
      from_date: "",
      fromdate: "2022-03-09",
      cities:[],
       show1: false,
       show2 : false,  
      loginusername : "",
      loginpassword : "",
      loginDamnnId : "",
      emailRules: [
        v => !!v || "Please enter your email address",
        v =>
          /.+@.+\..+/.test(v) ||
          "This doesn't appear to be a valid email address"
      ],
      passwordRule: [
        v => v.length >= 6 || "Password must be at least 6 characters"
      ],
      confirmpasswordRule: [
        v => v.length >= 6 || "Confirm Password must be at least 6 characters",
         v =>
          v === this.password || 'The password confirmation does not match.',
      ],
      regionRule: [
        v => !!v || "Pleas Select the country"
      ],
       cityRule: [
        v => !!v || "Please Select the city."
      ],
      stateidRule: [
        v => !!v || "Please Select the state."
      ],
      phoneRule: [
        v => !!v || "Please enter your phone number.",
        v => /^\+[1-9]\d{7,14}$/.test((v || "").replace(/[\s()-]/g, "")) ||
          "Include your country code, e.g. +14155551234"
      ],
      firstnameRule: [
        v => !!v || "Please enter your first name"
      ],
      lastnameRule: [
        v => !!v || "Please enter your surname"
      ],
      dobRule: [
        v => !!v || "Please enter your date of birth"
      ],
      suburbRule: [
        v => !!v || "Please enter your city or suburb"
      ],
      postcodeRule: [
        v => !!v || "Please enter your post code / zip code"
      ],
      captchaRule: [
        v => !!v || "Please answer the question",
        v => parseInt(v, 10) === this.captchaA + this.captchaB || "That answer isn't correct"
      ],
      otpRule: [
        v => !!v || "Please enter the code we texted you",
        v => /^\d{6}$/.test(v || "") || "The code is 6 digits"
      ],
      /* usernameRule: [
        v => !!v || "Please enter your username."
      ],*/
      genderarr:["Male","Female","Other"],
      loginusernameRule: [
        v => !!v || "Please enter username"
      ],
      loginpasswordRule: [
        v => !!v || "Please enter password"
      ],
      logindamnnidRule: [
        v => !!v || "Please enter DamnnId"
      ],
      tab: null,
      error:false,
      errorText:"",
      errorlist:[],
      videodisplay:false
    };
  },
  computed: {
    maxdob() {
      // must be at least 18 years old
      var d = new Date();
      d.setFullYear(d.getFullYear() - 18);
      return d.toISOString().slice(0, 10);
    }
  },
  mounted(){
    this.newcaptcha();
  },
  beforeDestroy(){
    this.stopresendtimer();
  },
  methods: 
  {
    formatdate(event){
      var delimeter = "/";
       if(event.code != "Backspace")
       {
         if(this.dob.length == 2 || this.dob.length == 5)
         {
           this.dob = this.dob + delimeter;
         }
       }
       else
       {
          if(event.code == "Backspace")   
          {
             if(this.dob.length == 2)
            {
              this.dob = '';
            }
          } 
       }
    },   
    newcaptcha(){
      this.captchaA = Math.floor(Math.random() * 9) + 1;
      this.captchaB = Math.floor(Math.random() * 9) + 1;
      this.captchaAnswer = "";
    },
    /*
     * Submit = step 1 only. The form is checked in the browser first, then the
     * backend re-validates everything and tells us whether the email / mobile
     * are already registered. Only once it has texted a code do we show the
     * OTP dialog; the account itself is created after the code checks out.
     */
    validate() {
      if (!this.$refs.form.validate()) {
        this.scrolltofirstinvalid();
        return;
      }
      this.errorlist = [];
      this.error = false;
      this.makedisable = true;

      this.$store.dispatch("sendRegisterOtp", this.otppayload())
        .then(response => {
          this.makedisable = false;
          if (!response.data.status) {
            // email / mobile already registered, or a field the browser missed.
            // Leave the captcha alone - resetting it here fires a second red
            // error on a question the user already answered correctly.
            this.showerror(response.data.errors || response.data.message);
            return;
          }
          this.otp = "";
          this.otperror = "";
          this.testcode = this.readtestcode(response);
          this.otpdialog = true;
          this.startresendtimer();
        })
        .catch(error => {
          this.makedisable = false;
          this.showerror(this.readerror(error, "We could not start your registration. Please try again."));
        });
    },
    otppayload() {
      return {
        firstname: this.firstname,
        lastname : this.lastname,
        email    : this.email,
        phone    : this.phone,
        dob      : this.dob,
        password : this.password,
        region   : this.region,
        stateid  : this.stateid,
        suburb   : this.suburb,
        postcode : this.postcode,
      };
    },
    verifyotp() {
      if (!this.$refs.otpform.validate()) {
        return;
      }
      this.otperror = "";
      this.otploading = true;

      this.$store.dispatch("verifyRegisterOtp", { phone: this.phone, otp: this.otp })
        .then(response => {
          if (!response.data.status) {
            this.otploading = false;
            this.otperror = this.tolist(response.data.errors || response.data.message).join(" ");
            return;
          }
          // Mobile confirmed - now actually create the account.
          this.register();
        })
        .catch(error => {
          this.otploading = false;
          this.otperror = this.readerror(error, "We could not verify that code. Please try again.");
        });
    },
    resendotp() {
      if (this.resendin > 0) {
        return;
      }
      this.otperror = "";
      this.$store.dispatch("sendRegisterOtp", this.otppayload())
        .then(response => {
          if (!response.data.status) {
            this.otperror = this.tolist(response.data.errors || response.data.message).join(" ");
            return;
          }
          this.otp = "";
          this.testcode = this.readtestcode(response);
          this.startresendtimer();
        })
        .catch(error => {
          this.otperror = this.readerror(error, "We could not resend the code. Please try again.");
        });
    },
    // local development only - empty unless the backend is in OTP test mode
    readtestcode(response) {
      var result = response && response.data ? response.data.result : null;
      return result && result.test_mode ? result.test_code : "";
    },
    closeotp() {
      this.otpdialog = false;
      this.otp = "";
      this.testcode = "";
      this.otperror = "";
      this.otploading = false;
      this.stopresendtimer();
    },
    startresendtimer() {
      this.stopresendtimer();
      this.resendin = 60;
      this.resendtimer = setInterval(() => {
        this.resendin--;
        if (this.resendin <= 0) {
          this.stopresendtimer();
        }
      }, 1000);
    },
    stopresendtimer() {
      if (this.resendtimer) {
        clearInterval(this.resendtimer);
        this.resendtimer = null;
      }
      this.resendin = 0;
    },
    readerror(error, fallback) {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message;
      }
      return fallback;
    },
    // The form is taller than the viewport, so a failing field can be off-screen.
    scrolltofirstinvalid() {
      this.$nextTick(() => {
        var invalid = this.$el.querySelector(".v-input.error--text");
        if (invalid && this.$vuetify && this.$vuetify.goTo) {
          this.$vuetify.goTo(invalid, { duration: 300, offset: 100 });
        }
      });
    },
    /*
     * Show a form-level error. The message sits above a long form, so scroll it
     * into view - otherwise the submit just appears to do nothing.
     */
    showerror(message) {
      this.errorlist = this.tolist(message);
      this.error = this.errorlist.length > 0;
      this.$nextTick(() => {
        var box = this.$refs.errorbox;
        var el = box && box.$el ? box.$el : box;
        if (el && this.$vuetify && this.$vuetify.goTo) {
          this.$vuetify.goTo(el, { duration: 300, offset: 80 });
        } else {
          var top = document.getElementById("errordivtop");
          if (top) { top.scrollIntoView({ behavior: "smooth" }); }
        }
      });
    },
    /*
     * Accepts the structured `errors` array, or falls back to splitting the
     * legacy <br>-joined `message` string so one message per line is shown
     * rather than raw markup.
     */
    tolist(message) {
      if (Array.isArray(message)) {
        return message;
      }
      return String(message || "")
        .split(/\s*<br\s*\/?>\s*/i)
        .map(m => m.trim())
        .filter(m => m.length);
    },
    register() {
      this.makedisable = true;
      this.$store
        .dispatch("register", {
          username  : this.username,
          firstname : this.firstname,
          lastname  : this.lastname,
          email     : this.email,
          password  : this.password,
          region    : this.region,
          referral  : this.referral,
          qrcodescan: this.qrcodescan,
          dob       : this.dob,
          gender    : this.gender,
          cityname  : this.suburb,
          suburb    : this.suburb,
          postcode  : this.postcode,
          stateid   : this.stateid,
          phone     : this.phone,
          app_type  : 'damnntips'
        })
        .then((response) => {
          if(response.data.status)
          {
            this.makedisable = false;
            //this.$store.commit('setActionModal',false);
            this.closeotp();

            this.$store.dispatch("retrieveTokenRegister",
                {username: this.email,password: this.password,damnnid:response.data.result.dammNId}).then(() => {

                this.$router.push({ name: "dashboard" });
            }).catch((error) => {
             this.makedisable = false;
             this.showerror(this.readerror(error, "Your account was created but we could not sign you in. Please log in."));
            });
          }
          else
          {
            // e.g. the verification lapsed between verifying and submitting
            this.makedisable = false;
            this.otploading = false;
            this.closeotp();
            this.newcaptcha();
            this.showerror(response.data.errors || response.data.message);
          }
        })
        .catch(error => {
          this.makedisable = false;
          this.otploading = false;
          this.closeotp();
          this.newcaptcha();
          this.showerror(this.readerror(error, "We could not create your account. Please try again."));
        });
    },
    getRegions(){
      this.$store.dispatch("retriveRegions").then(() => {
           this.regions = this.$store.getters.getregions;
      });
    },
     selectcities(getstate)
    {
    
       this.$store
        .dispatch("citieslist", {
          stateid    : getstate,
          countryname: this.region,
        })
        .then(response => {
          this.citiesarr = response.data;
          
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log(error);
        });
    },
      stateslist(getcountry)
    {
    
       this.$store
        .dispatch("stateslist", {
          countryname: getcountry,
        })
        .then(response => {
          this.statesarr = response.data;
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log(error);
        });
    }
    
    
  }
};
</script>
<style >
.text-justify{font-size:10px !important;margin-bottom:0px !important;}
.v-tab{color: #6cbcf4 !important;font-size: 20px !important;} 
.v-tab:before, .v-tabs-slider {
    background-color: #6cbcf4 !important;
}
.v-responsive__sizer{padding-bottom: 43.33% !important;}
.errortext {
    padding: 5px;
    color: white;
}
.dobpicker input {
  font-size: 16px;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  padding-right: 40px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 4px;
  background: transparent;
  /*border: 1px solid #9e9e9e;
  box-shadow: 0 0.1em 0.3em rgb(0 0 0 / 5%);*/
  outline: 0;
}
.vdpHeadCellContent{font-size: 11px;}
.vdpComponent.vdpWithInput>input{color: black; }
.vdpComponent{width: 100%;}
</style>